var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.202772 0.229221C0.473135 -0.0764069 0.91148 -0.0764069 1.18184 0.229221L5.79723 5.44661C6.06759 5.75224 6.06759 6.24776 5.79723 6.55339L1.18184 11.7708C0.91148 12.0764 0.473135 12.0764 0.202772 11.7708C-0.0675907 11.4652 -0.0675907 10.9696 0.202772 10.664L4.32862 6L0.202772 1.336C-0.0675907 1.03037 -0.0675907 0.534848 0.202772 0.229221Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.b8a3040b88b6546af07068e6d5096643.svg";
export { ForwardRef as ReactComponent };